module.exports = __webpack_public_path__ + "img/temple_of_necromancy_small.3fe4befb.png";